import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

const MobileCardPaginator = ({ tableRows, totalRows, onPageChange, t }) => {
  const currentPage = tableRows?.currentPage || 1;
  const rowsPerPage = tableRows?.rowsPerPage || 10;
  const totalPages = Math.max(1, Math.ceil(totalRows / rowsPerPage));
  const firstItem = totalRows === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
  const lastItem = Math.min(currentPage * rowsPerPage, totalRows);

  const isPrevDisabled = currentPage <= 1;
  const isNextDisabled = currentPage >= totalPages;

  return (
    <div className="mobile-card-paginator">
      <button
        className={`mobile-card-paginator__btn ${
          isPrevDisabled ? "mobile-card-paginator__btn--disabled" : ""
        }`}
        onClick={() => !isPrevDisabled && onPageChange("prev")}
        disabled={isPrevDisabled}
      >
        <FontAwesomeIcon icon={faChevronLeft} />
      </button>

      <div className="mobile-card-paginator__info">
        <span className="mobile-card-paginator__page">
          {currentPage} / {totalPages}
        </span>
        <span className="mobile-card-paginator__total">
          {firstItem}-{lastItem} {t("paginator.of", "of")} {totalRows}
        </span>
      </div>

      <button
        className={`mobile-card-paginator__btn ${
          isNextDisabled ? "mobile-card-paginator__btn--disabled" : ""
        }`}
        onClick={() => !isNextDisabled && onPageChange("next")}
        disabled={isNextDisabled}
      >
        <FontAwesomeIcon icon={faChevronRight} />
      </button>
    </div>
  );
};

export default MobileCardPaginator;
